import React, { useState } from 'react'

// import { Typography, Card } from '@material-ui/core';
import "./style.css"

import UploadButtonControl from './UploadButtonControl';
// import AnexoItem from './AnexoItem';
import firebaseUtil from 'firebaseUtil';
import useNotification from 'notification';
import { Button, CircularProgress, IconButton, Typography } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { deleteObject, getStorage, ref } from "firebase/storage";
import { PField } from 'components/form/input/NestedField';

export default function Anexo(props) {
    const {
        // meta: { touched, error },
        // msgSemRegistro, // só qd é list
        // type,
        onChange,
        value,
        typeQt = 'unico',
        // viewType,
        multiple,
        limit = 1,
        // disabled = false,
        viewOnly,
        label,
        name = 'anexos',
    } = props
    const { showError } = useNotification()
    // const anexos = props.form.getValues().anexos // valor nao atualiza apos remoção de anexo
    const [loading, setLoading] = useState(false)
    let tmpFolder = "cliente/anexos/" + props.folder + "/"
    // let typeAccept = type
    // let tipoUnico = false
    // if (!typeQt || typeQt === 'multiplo') {
    //     tipoUnico = false
    // } else {
    //     tipoUnico = true
    // }

    // useEffect(() => {
    //     console.log('anexos', anexos)
    // }, [anexos, loading])

    // const addAnexo = (upFile) => {
    //     // console.log('anexo', upFile)
    //     // if (tipoUnico) {
    //     onChange(upFile)
    //     // }
    //     // else {
    //     //     onChange(arrayAtual => {
    //     //         let newArray = arrayAtual ? arrayAtual.slice() : []
    //     //         newArray = newArray.concat([upFile])
    //     //         newArray.sort((a, b) => new Date(b.dateCreate) - new Date(a.dateCreate))
    //     //         return newArray
    //     //     })
    //     // }
    // }

    const deleteAnexo = (anexo, onChange/*, index*/) => {
        if (window.confirm("Deseja realmente deletar este anexo?")) {
            if (anexo && anexo.storagePath) {
                setLoading(true)
                const nameUid = anexo.filename
                const storage = getStorage(firebaseUtil.firebaseApp)
                const storageRef = ref(storage, tmpFolder + nameUid)
                let docRef = storageRef
                // let arquivo = firebaseUtil.getStorageRef(anexo.storagePath)

                deleteObject(docRef).then(function () {
                    // File deleted successfully
                    // console.log('deletado')
                    // if (tipoUnico) {
                    onChange(null)
                    setLoading(false)
                    // } else {
                    //     onChange(arrayAtual => {
                    //         let newArray = arrayAtual ? arrayAtual.slice() : []
                    //         newArray.splice(index, 1);
                    //         return newArray
                    //     })
                    // }
                }).catch(function (error) {
                    // Uh-oh, an error occurred!
                    if (error.code && error.code === "storage/object-not-found") {

                        showError("Arquivo já removido")
                        // if (tipoUnico) {
                        onChange(null)
                        setLoading(false)
                        // } else {
                        //     onChange(arrayAtual => {
                        //         let newArray = arrayAtual ? arrayAtual.slice() : []
                        //         newArray.splice(index, 1);
                        //         return newArray
                        //     })
                        // }

                    } else {
                        console.log('error', JSON.stringify(error))
                        showError(error._baseMessage)
                    }
                });
            }
        }
    }

    // console.log('value', value) // null quando upo o arquivo

    // let listSort = value || []

    // let disableUpload = tipoUnico ? value ? true : false : listSort.length >= limit // não deixa anexar mais 
    // console.log('tipoUnico', tipoUnico)
    // console.log('value', value)

    // if (!viewType || viewType === "listagem") {
    //     //     return (
    //     //         <Card style={{ padding: 5, marginBottom: 15 }}>
    //     //             <div style={{ display: 'flex', justifyContent: "space-between", paddingBottom: 10 }}>
    //     //                 <div style={{ display: 'flex' }}>
    //     //                     <Typography variant="h6">{label}</Typography>
    //     //                     {touched && error && <span style={{ fontSize: 12, alignSelf: 'center', color: '#ff5964', height: 35 }}>{error}</span>}
    //     //                 </div>
    //     //                 {/* <UploadFile style={{ margin: 10 }} uploadSuccess={addAnexo} tmpFolder={tmpFolder} typeAccept={typeAccept} multiple={multiple} disableUpload={listSort.length === limit} disabled={disabled} /> */}
    //     //                 <UploadButtonControl
    //     //                     tmpFolder={tmpFolder}
    //     //                     uploadSuccess={addAnexo}
    //     //                     typeAccept={typeAccept}
    //     //                     multiple={typeQt !== 'unico' && multiple}
    //     //                     limitFiles={limit}
    //     //                     disabled={disabled || disableUpload} />
    //     //             </div>

    //     //             {tipoUnico ?
    //     //                 <>
    //     //                     {value && <AnexoItem anexo={value} deleteAnexo={deleteAnexo} type={type} disabled={disabled} />}
    //     //                 </>
    //     //                 : <>
    //     //                     {listSort.map((a, i) => <AnexoItem key={i} anexo={a} index={i} deleteAnexo={deleteAnexo} type={type} disabled={disabled} />)}
    //     //                     {!listSort.length && <Typography style={{ textAlign: 'center' }}>{msgSemRegistro || "Sem anexos"}</Typography>}
    //     //                 </>
    //     //             }
    //     //         </Card>
    //     //     )
    // } else {
    return (
        <PField name={name}>
            {(fieldProps) => {
                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {/* <Button onClick={() => console.log('form', props.form.getValues().anexos)}>FORM</Button>
            <Button onClick={() => console.log('values', value)}>ANEXOS</Button> */}
                        {loading
                            ? <CircularProgress style={{ alignSelf: 'center', margin: 10 }} />
                            : <>
                                {viewOnly
                                    ? <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size={'small'}
                                            component="label"
                                            style={{ marginTop: 15, marginRight: 10, alignSelf: 'center' }}
                                            onClick={() => { window.open(value ? value?.downloadURL : fieldProps.input.value?.downloadURL, '_blank') }}
                                            disabled={value?.downloadURL || fieldProps.input.value?.downloadURL ? false : true}
                                        >
                                            {label ? label : 'Ver Anexo'}
                                        </Button>
                                    </div>
                                    : fieldProps.input.value || value
                                        ? <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size={'small'}
                                                component="label"
                                                style={{ marginTop: 15, marginRight: 10, alignSelf: 'center' }}
                                                onClick={() => { window.open(value ? value?.downloadURL : fieldProps.input.value?.downloadURL, '_blank') }}
                                            >
                                                {label ? label : 'Ver Anexo'}
                                            </Button>

                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems: 'center', marginTop: 10, height: '100%', gap: 2 }}>
                                                <Typography>
                                                    {value ? value?.realName : fieldProps.input.value?.realName || ''}
                                                </Typography>
                                                <div style={{ flex: 1 }}></div>
                                                <Typography variant="caption" display="block" gutterBottom>
                                                    {value ? value?.userName : fieldProps.input.value?.userName || ''}
                                                </Typography>
                                            </div>
                                            <IconButton
                                                onClick={() => deleteAnexo(value ? value : fieldProps.input.value, onChange ? onChange : (c) => { fieldProps.input.onChange(c) })}
                                                style={{ width: '2em', alignSelf: 'center' }}
                                            >
                                                <Delete />
                                            </IconButton>
                                        </div>
                                        : <div className='AnexoContButtonOnly'>
                                            <UploadButtonControl
                                                tmpFolder={tmpFolder}
                                                uploadSuccess={onChange ? onChange : (c) => { fieldProps.input.onChange(c) }}
                                                // typeAccept={typeAccept}
                                                multiple={typeQt !== 'unico' && multiple}
                                                limitFiles={limit}
                                                loading={loading}
                                                setLoading={setLoading}
                                            // disabled={disabled || disableUpload}
                                            />
                                        </div>
                                }
                            </>
                        }
                    </div>
                )
            }}
        </PField>
    )
    // }
}

